import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Badge, Spinner, Modal } from 'react-bootstrap';
import { FaRobot, FaPlay, FaTimes, FaShieldAlt, FaChartBar, FaGlobe, FaChevronRight, FaServer, FaLock, FaBolt, FaClock, FaCopy, FaCheckCircle, FaUserLock, FaDatabase, FaKey } from 'react-icons/fa';
import api from '../services/api';

const Home = ({ setCurrentView }) => {
    const [loading, setLoading] = useState(true);
    const [showVideo, setShowVideo] = useState(false);
    const [homeData, setHomeData] = useState(null);
    const [copiedField, setCopiedField] = useState(null);

    useEffect(() => {
        const fetchHomeData = async () => {
            try {
                const res = await api.get(`/public/pricing-data?v=${Math.random()}`); 
                if (res.data.success) {
                    setHomeData(res.data.config?.home_content || {});
                }
            } catch (err) {
                console.error("Lỗi tải cấu hình:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchHomeData();
    }, []);

    const triggerCopy = (text, fieldName) => {
        navigator.clipboard.writeText(text);
        setCopiedField(fieldName);
        setTimeout(() => setCopiedField(null), 2000);
    };

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh', backgroundColor: '#020617'}}>
            <Spinner animation="grow" variant="warning" />
        </div>
    );

    const d = homeData || {};
    const heroVideoId = "DbISEKG1V6A";
    const mobileEmbedUrl = `https://www.youtube.com/embed/${heroVideoId}?autoplay=1&mute=1&loop=1&playlist=${heroVideoId}&controls=1&modestbranding=1&rel=0`;

    return (
        <div className="home-platform-wrapper" style={{ backgroundColor: '#020617', overflowX: 'hidden', color: '#fff' }}>
            
            {/* --- SECTION 1: HERO --- */}
            <section className="position-relative d-flex align-items-center" style={{ minHeight: '85vh', padding: '100px 0' }}>
                <div className="position-absolute shadow-glow-decor" style={{ top: '10%', right: '5%', width: '500px', height: '500px', background: 'rgba(234, 179, 8, 0.08)', filter: 'blur(150px)', zIndex: 0 }}></div>
                
                <Container className="position-relative" style={{ zIndex: 1 }}>
                    <Row className="align-items-center g-5">
                        <Col lg={7} className="text-center text-lg-start">
                            <Badge bg="none" className="mb-4 px-4 py-2 text-gold-highlight border border-warning border-opacity-50 rounded-pill shadow-glow font-mono" style={{ letterSpacing: '3px', fontSize: '0.75rem' }}>
                                <FaShieldAlt className="me-2 animate-pulse"/> SECURE_ALGORITHMIC_TERMINAL_V2
                            </Badge>
                            
                            <h1 className="fw-black text-gold-highlight uppercase font-main mb-4" 
                                style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)', lineHeight: '1.4', letterSpacing: '-3px', paddingTop: '15px' }}>
                                {d.hero_title || 'NEXBOT SYSTEM'}
                            </h1>

                            <p className="lead mb-5 text-white-50 mx-auto mx-lg-0 font-main" style={{ maxWidth: '550px', fontSize: '1.2rem', lineHeight: '1.6' }}>
                                Bạn đang chạm tay vào cánh cửa của cuộc sống tự do tài chính. 
                                Hệ thống Bot trading Ai tự động sẽ biến giấc mơ của bạn thành hiện thực.
                            </p>
                            
                            <div className="d-flex justify-content-center justify-content-lg-start gap-3">
                                <Button variant="warning" className="btn-luxury-gold px-5 py-3 fw-bold shadow-lg" onClick={() => setCurrentView('register')} style={{ borderRadius: '12px', fontSize: '1.1rem' }}>
                                    KHỞI CHẠY HỆ THỐNG <FaChevronRight className="ms-2" size={12}/>
                                </Button>
                                
                                <Button variant="outline-light" className="btn-glass px-4 py-3 fw-bold d-inline-block" onClick={() => setShowVideo(true)} style={{ borderRadius: '12px' }}>
                                    <FaPlay className="me-2" size={12}/> XEM VIDEO
                                </Button>
                            </div>
                        </Col>

                        <Col lg={5} className="text-center">
                            <div className="d-none d-lg-block image-stack position-relative animate-float">
                                <img src={d.hero_img || "https://i.postimg.cc/FHjdhXHB/Gemini-Generated-Image-yenkz2yenkz2yenk.png"} 
                                    alt="NeXBot Core" 
                                    className="img-fluid rounded-5 shadow-2xl border border-warning border-opacity-20" 
                                    style={{ transform: 'perspective(1000px) rotateY(-15deg)', maxWidth: '110%' }} 
                                />
                            </div>

                            <div className="d-block d-lg-none mt-4 px-2">
                                <div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-glow border border-warning border-opacity-25">
                                    <iframe 
                                        src={mobileEmbedUrl} 
                                        title="NeXBot Mobile Preview" 
                                        allow="autoplay; encrypted-media" 
                                        allowFullScreen>
                                    </iframe>
                                </div>
                                <p className="font-mono text-warning mt-2 small text-center" style={{ fontSize: '0.7rem' }}>
                                    <FaPlay size={10} className="me-1"/> Chạm vào video để bật âm thanh
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* --- SECTION 2: INVESTOR PASSPORT (SÁNG ĐÈN CHÂN THỰC) --- */}
            <div className="stats-bar-container py-4 position-relative">
                <Container>
                    <div className="text-center mb-3">
                        <small className="font-mono text-warning text-uppercase" style={{ letterSpacing: '4px', fontSize: '0.75rem' }}>
                            ⚡ LIVE_MONITORING_ACCOUNT
                        </small>
                                <h2 className="fw-black text-gold-highlight uppercase font-main tracking-tighter" 
                                    style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: '1.6', paddingTop: '15px', marginBottom: '10px' }}>
                                    TÀI KHOẢN TRADING THỰC 
                                </h2>
                                <small className="font-mono text-warning text-uppercase" style={{ letterSpacing: '4px', fontSize: '0.75rem' }}>
                             EXNESS (CHẾ ĐỘ CHỈ XEM) ⚡
                        </small>
                        
                    </div>
                    <div className="stats-glass-panel account-glow-active">
                        <Row className="text-center g-0 divide-line align-items-center">
                            {/* Ô 1: ID ĐĂNG NHẬP */}
                            <Col md={4} sm={12} className="stat-item py-4 position-relative">
                                <div className="stat-icon-mini text-cyan"><FaUserLock size={16}/></div>
                                <div className="stat-value text-cyan font-mono mt-1">183965674</div>
                                <div className="stat-label font-mono d-flex align-items-center justify-content-center gap-2">
                                    ID ĐĂNG NHẬP 
                                    <Button size="sm" variant="link" className="p-0 btn-copy-gold" onClick={() => triggerCopy("183965674", "id")}>
                                        {copiedField === 'id' ? <FaCheckCircle className="text-success" size={14}/> : <FaCopy size={13}/>}
                                    </Button>
                                </div>
                            </Col>
                            
                            {/* Ô 2: MÁY CHỦ SÀN */}
                            <Col md={4} sm={12} className="stat-item py-4 position-relative">
                                <div className="stat-icon-mini text-amber"><FaDatabase size={16}/></div>
                                <div className="stat-value text-amber font-mono mt-1">MT5 Real 25</div>
                                <div className="stat-label font-mono d-flex align-items-center justify-content-center gap-2">
                                    MÁY CHỦ SERVER 
                                    <Button size="sm" variant="link" className="p-0 btn-copy-gold" onClick={() => triggerCopy("MT5 Real 25", "server")}>
                                        {copiedField === 'server' ? <FaCheckCircle className="text-success" size={14}/> : <FaCopy size={13}/>}
                                    </Button>
                                </div>
                            </Col>
                            
                            {/* Ô 3: MẬT KHẨU INVESTOR */}
                            <Col md={4} sm={12} className="stat-item py-4 position-relative">
                                <div className="stat-icon-mini text-emerald"><FaKey size={16}/></div>
                                <div className="stat-value text-emerald font-mono mt-1">3Vibbot2026@</div>
                                <div className="stat-label font-mono d-flex align-items-center justify-content-center gap-2">
                                    PASS INVESTOR
                                    <Button size="sm" variant="link" className="p-0 btn-copy-gold" onClick={() => triggerCopy("3Vibbot2026@", "pass")}>
                                        {copiedField === 'pass' ? <FaCheckCircle className="text-success" size={14}/> : <FaCopy size={13}/>}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            {/* --- SECTION 3: CORE MISSIONS --- */}
            <section className="py-5">
                <Container className="py-5">
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={10}>
                            <div className="tech-header-container mb-5">
                                <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                                    <span className="tech-dot"></span>
                                    <span className="tech-line"></span>
                                    <Badge bg="none" className="text-warning font-mono small fw-normal" style={{letterSpacing: '4px'}}>
                                        SYSTEM_CORE_INIT
                                    </Badge>
                                    <span className="tech-line"></span>
                                    <span className="tech-dot"></span>
                                </div>
                                
                                <h2 className="fw-black text-gold-highlight uppercase font-main tracking-tighter" 
                                    style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: '1.6', paddingTop: '15px', marginBottom: '10px' }}>
                                    CÔNG NGHỆ DẪN ĐẦU
                                </h2>
                                
                                <div className="console-wrapper mx-auto">
                                    <p className="font-mono text-secondary m-0 py-2 px-3 d-inline-block rounded shadow-sm" 
                                       style={{ background: 'rgba(255,255,255,0.03)', borderLeft: '3px solid #eab308' }}>
                                        <span className="text-warning">{'>'}</span> Hệ thống hạ tầng hoàn chỉnh cho nhà đầu tư chuyên nghiệp<span className="cursor-blink">_</span>
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {[
                            { 
                                id: "01", icon: <FaChartBar/>, title: "Data Driven", glow: "glow-blue",
                                desc: "Hàng trăm phép tính được thực hiện trước mỗi hành động vào lệnh ."
                            },
                            { 
                                id: "02", icon: <FaRobot/>, title: "Fully Automated", glow: "glow-gold",
                                desc: "Hệ thống Ai Bot trading sẽ giúp bạn kiếm tiền ngay cả khi bạn đang ngủ."
                            },
                            { 
                                id: "03", icon: <FaGlobe/>, title: "Global Access", glow: "glow-emerald",
                                desc: "Hỗ trợ đa nền tảng, bằng máy tính cá nhân và trên VPS."
                            }
                        ].map((item, idx) => (
                            <Col md={4} key={idx}>
                                <div className={`p-5 rounded-4 h-100 feature-card ${item.glow}`} 
                                     style={{ background: '#0b1221', border: '1px solid rgba(255,255,255,0.05)', position: 'relative', cursor: 'pointer', overflow: 'visible' }}>
                                    <div className="font-mono position-absolute top-0 end-0 p-3 opacity-10 text-white h3 m-0">{item.id}</div>
                                    <div className="feature-icon mb-4 fs-1 transition-all">{item.icon}</div>
                                    
                                    <h4 className="text-gold-highlight fw-bold mb-3 font-main" 
                                        style={{ fontSize: '1.5rem', lineHeight: '1.5', paddingTop: '10px' }}>
                                        {item.title}
                                    </h4>
                                    
                                    <p className="text-secondary mb-0" style={{ lineHeight: '1.7', opacity: 0.8, fontSize: '0.95rem' }}>{item.desc}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* MODAL VIDEO */}
            <Modal show={showVideo} onHide={() => setShowVideo(false)} centered size="lg" contentClassName="bg-black border-warning border-opacity-25 shadow-2xl">
                <Modal.Body className="p-0 position-relative bg-black">
                    <Button variant="link" className="position-absolute top-0 end-0 text-warning z-index-10 p-3" onClick={() => setShowVideo(false)} style={{zIndex: 99}}>
                        <FaTimes size={24} />
                    </Button>
                    <div className="ratio ratio-16x9">
                        <iframe 
                            src={`https://www.youtube.com/embed/${heroVideoId}?autoplay=1&mute=0&rel=0`} 
                            title="NeXBot Introduction" 
                            allow="autoplay; encrypted-media" 
                            allowFullScreen>
                        </iframe>
                    </div>
                </Modal.Body>
            </Modal>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&family=Fira+Code:wght@400;700&display=swap');

                .font-main { font-family: 'Inter', sans-serif !important; }
                .font-mono { font-family: 'Fira Code', 'Courier New', monospace !important; }
                .fw-black { font-weight: 900; }
                .uppercase { text-transform: uppercase; }
                
                .text-gold-highlight { 
                    background: linear-gradient(135deg, #eab308 0%, #fef3c7 50%, #eab308 100%); 
                    -webkit-background-clip: text; 
                    -webkit-text-fill-color: transparent; 
                    background-clip: text;
                    display: block;
                    overflow: visible !important;
                }
                
                .btn-luxury-gold { background: linear-gradient(135deg, #eab308 0%, #fbbf24 100%) !important; border: none !important; color: #000 !important; transition: 0.3s; }
                .btn-luxury-gold:hover { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(234, 179, 8, 0.4) !important; }
                .btn-glass { background: rgba(255, 255, 255, 0.05) !important; border: 1px solid rgba(255, 255, 255, 0.1) !important; backdrop-filter: blur(10px); }

                /* HIỆU ỨNG SÁNG ĐÈN CHO CARD TỔNG QUAN */
                .stats-glass-panel.account-glow-active {
                    background: rgba(11, 18, 33, 0.8);
                    border: 1px solid #eab308 !important;
                    border-radius: 20px;
                    backdrop-filter: blur(20px);
                    /* Đổ bóng Neon hổ phách phát sáng lan tỏa rộng */
                    box-shadow: 0 0 35px rgba(234, 179, 8, 0.25), 
                                inset 0 0 20px rgba(234, 179, 8, 0.1) !important;
                    padding: 12px 25px;
                    transition: 0.4s;
                }
                .stats-glass-panel.account-glow-active:hover {
                    box-shadow: 0 0 50px rgba(234, 179, 8, 0.4), 
                                inset 0 0 25px rgba(234, 179, 8, 0.15) !important;
                }

                .stat-value { font-family: 'Fira Code', monospace !important; font-weight: 700; font-size: 1.5rem; line-height: 1.2; letter-spacing: -0.5px; }
                .stat-label { font-family: 'Fira Code', monospace !important; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: #64748b; font-weight: 700; margin-top: 10px; }
                .divide-line .stat-item:not(:last-child) { border-right: 1px solid rgba(234, 179, 8, 0.15); }
                
                /* NÚT COPY MÀU VÀNG RÕ HƠN */
                .btn-copy-gold { 
                    color: #eab308 !important; 
                    opacity: 0.75;
                    transition: all 0.2s ease-in-out; 
                    background: none;
                    border: none;
                    display: inline-flex;
                    align-items: center;
                }
                .btn-copy-gold:hover { 
                    opacity: 1 !important;
                    transform: scale(1.25);
                    text-shadow: 0 0 10px #eab308;
                }

                .text-cyan { color: #22d3ee !important; text-shadow: 0 0 15px rgba(34, 211, 238, 0.3); }
                .text-amber { color: #fbbf24 !important; text-shadow: 0 0 15px rgba(251, 191, 36, 0.3); }
                .text-emerald { color: #34d399 !important; text-shadow: 0 0 15px rgba(52, 211, 153, 0.3); }

                .tech-line { width: 40px; height: 1px; background: linear-gradient(90deg, transparent, rgba(234, 179, 8, 0.5), transparent); }
                .tech-dot { width: 4px; height: 4px; background: #eab308; border-radius: 50%; box-shadow: 0 0 10px #eab308; }
                .cursor-blink { animation: blink 1s step-end infinite; color: #eab308; }
                @keyframes blink { from, to { opacity: 1; } 50% { opacity: 0; } }

                .feature-card { transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); }
                .feature-card::before {
                    content: ""; position: absolute; top: 0; left: 0; width: 20px; height: 20px;
                    border-top: 2px solid rgba(234, 179, 8, 0.3); border-left: 2px solid rgba(234, 179, 8, 0.3);
                    border-radius: 4px 0 0 0;
                }
                .feature-icon { color: #475569; }
                
                .glow-blue:hover { border-color: #22d3ee !important; box-shadow: 0 0 30px rgba(34, 211, 238, 0.15), inset 0 0 10px rgba(34, 211, 238, 0.05); transform: translateY(-10px); }
                .glow-blue:hover .feature-icon { color: #22d3ee; text-shadow: 0 0 15px rgba(34, 211, 238, 0.6); }
                
                .glow-gold:hover { border-color: #fbbf24 !important; box-shadow: 0 0 30px rgba(251, 191, 36, 0.15), inset 0 0 10px rgba(251, 191, 36, 0.05); transform: translateY(-10px); }
                .glow-gold:hover .feature-icon { color: #fbbf24; text-shadow: 0 0 15px rgba(251, 191, 36, 0.6); }
                
                .glow-emerald:hover { border-color: #34d399 !important; box-shadow: 0 0 30px rgba(52, 211, 153, 0.15), inset 0 0 10px rgba(52, 211, 153, 0.05); transform: translateY(-10px); }
                .glow-emerald:hover .feature-icon { color: #34d399; text-shadow: 0 0 15px rgba(52, 211, 153, 0.6); }

                .animate-float { animation: float 6s ease-in-out infinite; }
                @keyframes float { 0%, 100% { transform: translateY(0px) rotateY(-15deg); } 50% { transform: translateY(-20px) rotateY(-10deg); } }
                .animate-pulse { animation: pulse 2s infinite; }
                @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.4; } 100% { opacity: 1; } }
                .shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.8); }

                @media (max-width: 768px) {
                    .divide-line .stat-item { border-right: none !important; border-bottom: 1px solid rgba(234, 179, 8, 0.15); }
                    .divide-line .stat-item:last-child { border-bottom: none; }
                }
            `}</style>
        </div>
    );
};

export default Home;